package nl.volleyplanner.web.base.component

import kotlinx.html.*
import kotlinx.html.js.onClickFunction
import kotlinx.html.org.w3c.dom.events.Event
import nl.volleyplanner.web.base.icon

enum class BootstrapButtonStyle(val cssClass: String?) {
    NoStyle(null),
    Primary("btn-primary"),
    Secondary("btn-secondary"),
    Warning("btn-warning"),
    Danger("btn-danger"),
    Info("btn-info"),
    // TODO: All types
}

fun FlowContent.iconButton(buttonStyle: BootstrapButtonStyle, icon: String, cssClasses: Set<String> = emptySet(), jsOnClickFunction: (Event) -> Unit) {
    button(classes = "btn ms-1") {
        style =
            "--bs-btn-padding-y: .1rem; --bs-btn-padding-x: .2rem; margin-right: 0.1em; aspect-ratio: 1 / 1;"

        if (buttonStyle.cssClass != null) {
            classes += setOf(buttonStyle.cssClass, "btn-sm")
            style += " --bs-btn-font-size: .75rem; "
        }
        classes += cssClasses

        onClickFunction = jsOnClickFunction

        icon(icon)
        span(classes = "visually-hidden") {}
    }
}